import { Box, Grid } from '@mui/material';
import {
    AppCurrentVisits,
    AppWebsiteVisits,
    AppWidgetSummary
} from '../../sections/@dashboard/app';
import i18n from '../../i18n';
import React from 'react';

export default function MerchantDashboardContent({ data }) {
    const ordersByDate = data?.ordersByDate || [];
    const paymentOrders = data?.paymentOrders || [];
    const datesLabelsPaymentOrders = data?.datesLabelsPaymentOrders || [];
    const { balance } = data;
    // balance
    const availableBalance = balance?.availableBalance || 0;
    const receivedBalance = balance?.receivedBalance || 0;
    const totalBalance = balance?.totalBalance || 0;
    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                mb={3}
                gap={2}
                flexWrap={{
                    xs: 'wrap',
                    sm: 'wrap',
                    md: 'nowrap'
                }}
                sx={{ minHeight: '150px' }}
            >
                <Box flexBasis="100%">
                    <AppWidgetSummary
                        title={i18n.t('dashboard.balance.details.total.title')}
                        showOnlyCount={true}
                        count={totalBalance}
                        countTooltip={i18n.t(
                            'dashboard.balance.details.total.tooltip'
                        )}
                    />
                </Box>
                <Box flexBasis="100%">
                    <AppWidgetSummary
                        title={i18n.t(
                            'dashboard.balance.details.available.title'
                        )}
                        showOnlyCount={true}
                        count={availableBalance}
                        countTooltip={i18n.t(
                            'dashboard.balance.details.available.tooltip'
                        )}
                    />
                </Box>
                <Box flexBasis="100%">
                    <AppWidgetSummary
                        title={i18n.t(
                            'dashboard.balance.details.received.title'
                        )}
                        showOnlyCount={true}
                        count={receivedBalance}
                        countTooltip={i18n.t(
                            'dashboard.balance.details.received.tooltip'
                        )}
                    />
                </Box>
            </Box>
            <Grid container spacing={3} alignItems="stretch">
                <Grid item xs={12} md={9} lg={9}>
                    <AppWebsiteVisits
                        title={i18n.t('dashboard.ordersByDate')}
                        subheader=""
                        chartLabels={datesLabelsPaymentOrders}
                        chartData={Object.entries(ordersByDate).map((field) => {
                            return {
                                name: i18n.t(`dashboard.${field[0]}`),
                                type: 'line',
                                fill: 'solid',
                                data: field[1]
                            };
                        })}
                    />
                </Grid>

                <Grid item xs={12} md={3} lg={3}>
                    <AppCurrentVisits
                        title={i18n.t('dashboard.paymentOrdersByStatus')}
                        chartData={Object.entries(paymentOrders).map(
                            (field) => {
                                return {
                                    label: field[0],
                                    value: field[1]
                                };
                            }
                        )}
                        chartColors={
                            [
                                // theme.palette.primary.main,
                                // theme.palette.info.main,
                                // theme.palette.warning.main,
                                // theme.palette.error.main,
                            ]
                        }
                    />
                </Grid>
            </Grid>
        </>
    );
}
